import React from 'react';

const ContentLayoutContext = React.createContext(null);
export default ContentLayoutContext;
